import {getTimeDifference} from '../timeFunctions.js'

// THIS IS PRIVEW PRICING
export let getDefaultStartingFromPrices=(base, discounts)=>{
  var monthlyLowest = getMonthlyStartingFromDefault(base, discounts)
  var dailyLowest = getDailyStartingFromDefault(base, discounts)
  return {
    monthlyStartingFrom: monthlyLowest,
    dailyStartingFrom: dailyLowest
  }
}


function getMonthlyStartingFromDefault(base, discounts){
  if(discounts && base.rentMonthly) {
    if(discounts.longPeriodDiscount)
      return (base.rentMonthly-(base.rentMonthly*discounts.longPeriodDiscount/100)).toFixed(0)
    else if(discounts.mediumPeriodDiscount)
      return (base.rentMonthly-(base.rentMonthly*discounts.mediumPeriodDiscount/100)).toFixed(0)
  }
  return base.rentMonthly
}

function getDailyStartingFromDefault(base, discounts){
  if(discounts && discounts.weeklyDiscount && base.rentDaily)
        return (base.rentDaily-(base.rentDaily*discounts.weeklyDiscount/100)).toFixed(0)
  return base.rentDaily
}

export let calcTotalDealWorth=(calculatedPrices)=>{
  if(calculatedPrices.priceTier == "month"){
    var fullMonthsRent = calculatedPrices.stayLength.months * calculatedPrices.rentMonthly
    var preAndPostDaysRent = calculatedPrices.rentForPreDays.total + calculatedPrices.rentForPostDays.total
    return fullMonthsRent+preAndPostDaysRent
  }else if(calculatedPrices.priceTier == "day"){
    return calculatedPrices.rentDaily * calculatedPrices.stayLength.totalNrOfDays
  }
}


export let calcMoowleBookingFee=(totalDealWorth, pricingRules, fees = {})=>{
  const moowleRentFeePercentage = !isNaN(fees.bookingFeePercentage) ? fees.bookingFeePercentage : pricingRules.min_moowle_rent_fee_percentage;
  const maxMoowleRentFee = !isNaN(fees.bookingFeeValue) ? fees.bookingFeeValue : pricingRules.min_moowle_rent_fee;
  var precentFromTotal = (totalDealWorth * moowleRentFeePercentage)/100
  if(precentFromTotal < maxMoowleRentFee) return precentFromTotal.toFixed(2)
  else return maxMoowleRentFee
}

// ******************
// CUSTOM OFFER CASE
export let calcRentPricingDetailsCustom=(customOffer, periodStart, periodEnd) => {
  var timeDiff = getTimeDifference(periodStart, periodEnd);
  if (timeDiff.years > 0 || timeDiff.months > 0) return calcMontlyRentPricingDetailsCustom(customOffer, timeDiff);
  else return calcDailyRentPricingDetailsCustom(customOffer, timeDiff);
}

function calcMontlyRentPricingDetailsCustom(customOffer, timeDiff){
  var dailyRentForPreDays = (customOffer/timeDiff.preDays.daysInMonth).toFixed(2)
  var totalRentForPreDays = (timeDiff.preDays.nrOfDaysStaying * dailyRentForPreDays).toFixed(2)

  var dailyRentForPostDays = (customOffer/timeDiff.postDays.daysInMonth).toFixed(2)
  var totalRentForPostDays = (timeDiff.postDays.nrOfDaysStaying * dailyRentForPostDays).toFixed(2)

  return {
    stayLength:timeDiff,
    rentForPreDays:{total: Number(totalRentForPreDays), daily:Number(dailyRentForPreDays)},
    rentForPostDays:{total:Number(totalRentForPostDays), daily:Number(dailyRentForPostDays)},
    rentMonthly:Number(customOffer),
    priceTier:"month",
  }
}

function calcDailyRentPricingDetailsCustom(customOffer, timeDiff){
  return {
    stayLength:timeDiff,
    rentDaily:Number(customOffer),
    priceTier:"day"
  }
}

export let calcRentPricingDetails = (baseRents, periodStart, periodEnd, discounts, pricingRules) => {
  var timeDiff = getTimeDifference(periodStart, periodEnd);
  console.log('calcRentPricingDetails');
  console.log('timeDiff:', timeDiff);

  if(baseRents.rentDaily && timeDiff.totalNrOfDays <= 30)return calcDailyRentPricingDetails(baseRents.rentDaily, timeDiff, discounts, pricingRules);
  else if(timeDiff.totalNrOfDays < 30){
    var a = Number(baseRents.rentMonthly / timeDiff.preDays.daysInMonth) * timeDiff.preDays.nrOfDaysStaying
    var b = Number(baseRents.rentMonthly / timeDiff.postDays.daysInMonth) * timeDiff.postDays.nrOfDaysStaying
    var baseRent = a+b/timeDiff.totalNrOfDays
    return calcDailyRentPricingDetails(baseRent, timeDiff, discounts, pricingRules);
  }else{
    return calcMontlyRentPricingDetails(baseRents, timeDiff, discounts, pricingRules);
  }
}

export let calcPricingTier = (periodStart, periodEnd) => {
  var timeDiff = getTimeDifference(periodStart, periodEnd);
  if (timeDiff.totalNrOfDays <= 30) return "day"
  else return "month"
}

function calcMontlyRentPricingDetails(baseRents, timeDiff, discounts, pricingRules){
  var monthlyBaseRent = getMonthlyBaseRent(baseRents)

  var rentMonthly = getMonthlyRentDiscountsApplied(monthlyBaseRent, timeDiff, discounts, pricingRules).toFixed(2)

  var dailyRentForPreDays = (rentMonthly/timeDiff.preDays.daysInMonth).toFixed(2)
  var totalRentForPreDays = (timeDiff.preDays.nrOfDaysStaying * dailyRentForPreDays).toFixed(2)

  var dailyRentForPostDays = (rentMonthly/timeDiff.postDays.daysInMonth).toFixed(2)
  var totalRentForPostDays = (timeDiff.postDays.nrOfDaysStaying * dailyRentForPostDays).toFixed(2)

  return {
    stayLength:timeDiff,
    rentForPreDays:{total: Number(totalRentForPreDays), daily:Number(dailyRentForPreDays)},
    rentForPostDays:{total:Number(totalRentForPostDays), daily:Number(dailyRentForPostDays)},
    rentMonthly:Number(rentMonthly),
    baseRent:baseRents,
    discounts: discounts,
    priceTier:"month",
  }
}

function calcDailyRentPricingDetails(baseRent, timeDiff, discounts, pricingRules){
  var rentDaily = baseRent.toFixed(2)
  if(timeDiff.totalNrOfDays >= pricingRules.min_weekly_discount_days)
    if(discounts.weeklyDiscount) rentDaily = (baseRent-(baseRent*discounts.weeklyDiscount/100)).toFixed(2)

  return {
    stayLength:timeDiff,
    rentDaily:Number(rentDaily),
    discounts: discounts,
    priceTier:"day"
  }
}
// MONTHLY HELPERS
function getMonthlyBaseRent(baseRent){
  if(baseRent.rentMonthly) return Number(baseRent.rentMonthly)
  return (baseRent.rentDaily * 30.43).toFixed(2)
}

function getMonthlyRentDiscountsApplied(monthlyBaseRent, timeDiff, discounts, pricingRules){
  if(timeDiff.totalNrOfDays > pricingRules.max_medium_rent_period_in_days)
    if(discounts.longPeriodDiscount) return (monthlyBaseRent-(monthlyBaseRent*discounts.longPeriodDiscount/100))

  if(timeDiff.totalNrOfDays > pricingRules.max_base_rent_period_in_days)
    if(discounts.mediumPeriodDiscount) return (monthlyBaseRent-(monthlyBaseRent*discounts.mediumPeriodDiscount/100))

  return monthlyBaseRent
}



// WEBPACK FOOTER //
// ./src/pricing/pricingCalculator.js